import { AttachmentPolicyInfoBarId } from '../schema/AttachmentPolicyInfoBarId';
import { assertNever } from 'owa-assert';
import { getOwaMailStrings } from 'owa-strings/owa-mail-strings';

import {
    InfoBarCustomAction,
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import strings from 'owa-strings/owa-mail-strings';

// TODO: VSO 32454 implement Access Control info bars
export default function getInfoBarMessageViewState(
    infoBarId: AttachmentPolicyInfoBarId
): InfoBarMessageViewState {
    switch (infoBarId) {
        case AttachmentPolicyInfoBarId.InfoRestrictedAccess:
            return {
                key: 'access_control_info_bar',
                source: InfoBarMessageSource.Compose,
                rank: InfoBarMessageRank.Error,
                messageParts: [
                    strings.attachmentPolicyInformation,
                    getLearnMoreInfoBarCustomAction(),
                ],
                color: InfoBarMessageColor.Red,
            };
        default:
            return assertNever(infoBarId);
    }
}

function getLearnMoreInfoBarCustomAction(): InfoBarCustomAction {
    const learnMoreUrl =
        'https://docs.microsoft.com/en-us/intune-user-help/use-managed-devices-to-get-work-done';
    return {
        text: getOwaMailStrings().attachmentPolicyHyperLinkText,
        action: () => {
            window.open(learnMoreUrl, '_blank');
        },
    } as InfoBarCustomAction;
}
